import React, { useContext } from "react";
import { personnelDetailContext } from "../../PersonnelDetail";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MatchRatio from "../../../../components/MatchRatio";
import PaginationListItem from "../molecules/PaginationListItem";

export default function Pagination() {
  const {
    personnelList = [],
    matchingIndex,
    setMatchingIndex,
    offset,
    setOffset,
    nextOffset,
    prevOffset,
    setPersonnelId,
  } = useContext(personnelDetailContext);

  const personnelListLength = personnelList.length;

  const clickPagination = (direction) => {
    if (personnelListLength === 0) return;

    let tempMatchingIndex = matchingIndex;
    if (direction === "back") {
      tempMatchingIndex = (tempMatchingIndex - 1 + personnelListLength) % personnelListLength;
      setPersonnelId(personnelList[tempMatchingIndex]?.id);
      if (matchingIndex - 1 === 0 && offset > 0) {
        setOffset(prevOffset);
      }
    } else if (direction === "forward") {
      tempMatchingIndex = (tempMatchingIndex + 1) % personnelListLength;
      setPersonnelId(personnelList[tempMatchingIndex]?.id);
      if (matchingIndex + 1 === personnelListLength - 1 && nextOffset > 0) {
        setOffset(nextOffset);
      }
    }

    setMatchingIndex(tempMatchingIndex);
  };

  const backIndex = (matchingIndex - 1 + personnelListLength) % personnelListLength;
  const forwardIndex = (matchingIndex + 1) % personnelListLength;

  const backPageInfo = personnelListLength > 0 ? personnelList[backIndex] : { id: 0, cost: 0, age: 0, match_ratio: 0 };
  const forwardPageInfo = personnelListLength > 0 ? personnelList[forwardIndex] : { id: 0, cost: 0, age: 0, match_ratio: 0 };

  const backPageInfoList = [
    { head: "ID", text: backPageInfo?.id || "" },
    { head: "単価", text: `${backPageInfo?.cost || 0}万円` },
    { head: "年齢", text: backPageInfo?.age || "" },
  ];

  const forwardPageInfoList = [
    { head: "ID", text: forwardPageInfo?.id || "" },
    { head: "単価", text: `${forwardPageInfo?.cost || 0}万円` },
    { head: "年齢", text: forwardPageInfo?.age || "" },
  ];

  const hideBack =
    (offset === 0 && prevOffset === 0 && matchingIndex === 0) ||
    (nextOffset === -1 && prevOffset === -1 && personnelListLength === 1);

  const hideForward =
    (nextOffset === 0 && personnelListLength - 1 === matchingIndex) ||
    (nextOffset === -1 && prevOffset === -1 && personnelListLength === 1);

  return (
    <Box sx={{ display: "flex", gap: "20px" }}>
      <Button
        variant="text"
        onClick={() => clickPagination("back")}
        sx={{
          width: "50%",
          color: "#333",
          p: { xs: "5px", sm: "20px" },
          bgcolor: "#f9f9fa",
          visibility: hideBack ? "hidden" : "visible",
        }}
      >
        <Box sx={{ height: "100%", width: "100%", display: "flex", alignItems: "center" }}>
          <ChevronLeftIcon />
          <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}>
            <MatchRatio
              ratio={backPageInfo?.match_ratio}
              width="60px"
              mainFontSize="24px"
              subFontSize="8px"
            />
            <Box sx={{ width: "100%", pl: "20px" }}>
              {backPageInfoList.map((item) => (
                <PaginationListItem key={item.head} head={item.head} text={item.text} />
              ))}
            </Box>
          </Box>
          <Box sx={{ display: { xs: "flex", sm: "none" }, flexGrow: 1 }}>
            <Box sx={{ width: "100%", textAlign: "left" }}>
              <PaginationListItem head={backPageInfoList[0].head} text={backPageInfoList[0].text} />
              <PaginationListItem head={backPageInfoList[1].head} text={backPageInfoList[1].text} />
              <PaginationListItem head={backPageInfoList[2].head} text={backPageInfoList[2].text} />
            </Box>
          </Box>
        </Box>
      </Button>

      <Button
        variant="text"
        onClick={() => clickPagination("forward")}
        sx={{
          width: "50%",
          color: "#333",
          p: { xs: "10px", sm: "20px" },
          bgcolor: "#f9f9fa",
          visibility: hideForward ? "hidden" : "visible",
        }}
      >
        <Box sx={{ height: "100%", width: "100%", display: "flex", alignItems: "center" }}>
          <Box sx={{ display: { xs: "none", sm: "flex", flexGrow: 1 }, alignItems: "center" }}>
            <Box sx={{ width: "100%", textAlign: "left", pr: "20px" }}>
              {forwardPageInfoList.map((item) => (
                <PaginationListItem key={item.head} head={item.head} text={item.text} />
              ))}
            </Box>
            <MatchRatio
              ratio={forwardPageInfo?.match_ratio}
              width="60px"
              mainFontSize="24px"
              subFontSize="8px"
            />
          </Box>
          <Box sx={{ display: { xs: "flex", sm: "none" }, flexGrow: 1 }}>
            <Box sx={{ width: "100%", textAlign: "left" }}>
              <PaginationListItem head={forwardPageInfoList[0].head} text={forwardPageInfoList[0].text} />
              <PaginationListItem head={forwardPageInfoList[1].head} text={forwardPageInfoList[1].text} />
              <PaginationListItem head={forwardPageInfoList[2].head} text={forwardPageInfoList[2].text} />
            </Box>
          </Box>
          <ChevronRightIcon />
        </Box>
      </Button>
    </Box>
  );
}